<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList } from "@unio/saltbox-ui"

import ContainerRow from "@/components/ContainerRow.vue"
import { useNavbar } from "@/composables/useNavbar"
import { pluralize } from "@/lib/format"
import { ICON } from "@/lib/icons"
import { inventoryPath } from "@/routes"
import type { ContainerSummary } from "@/types/models"

const { title } = useNavbar({ title: "Inventory Progress" })

interface Props {
  containers: ContainerSummary[]
}

defineProps<Props>()
</script>

<template>
  <Head :title="title" />

  <div v-if="containers.length" class="flex flex-col gap-2">
    <span class="text-muted text-xs">{{
      pluralize(containers.length, "top-level container")
    }}</span>
    <SbList bordered separator>
      <ContainerRow
        v-for="c in containers"
        :key="c.id"
        :container="c"
        variant="root"
        :to="inventoryPath(c.id)"
      />
    </SbList>
  </div>

  <UEmpty
    v-else
    :icon="ICON.container"
    title="No containers yet"
    description="Create containers to start tracking inventory progress."
  />
</template>
